startOfFileToken